import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    userProfile: (state) => state.userProfile,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const RemarqueComputed = {
  ...mapState('remarque', {
    Listecommentaire: (state) => state.Listecommentaire,
   }),
  ...mapGetters('remarque', ['Listecommentaire']),
}

export const ServiceComputed = {
  ...mapState('service', {
    ListeService: (state) => state.ListeService,
   }),
  ...mapGetters('service', ['ListeCategorieService','selectCategService','ListeService','selectService']),
}

export const AssuranceComputed = {
  ...mapState('assurance', {
    Assurance: (state) => state.Assurance,
    
   }),
  ...mapGetters('assurance', ['SelectSearchListeExpertAssurance','ListeExpertAssure','Assurance','SelectAssurance','ExpertAssurance','ExpertAssurre','SelectSearchListeAssurance']),
}

export const GestionnaireComputed = {
  ...mapState('gestionnaire', {
    Assurance: (state) => state.gestionnaire,
   }),
  ...mapGetters('gestionnaire', ['gestionnaire','selectGestionnaire']),
}

// Bureaux d'etudes de sol : liste partagee, stockee en base
export const EtudeSolComputed = {
  ...mapGetters('etudesol', ['ListeEtudeSol', 'ListeEtudeSolDetail']),
};

export const EtudeSolMethods = mapActions('etudesol', ['getEtudeSol', 'creerEtudeSol', 'ajouterEtudeSolLocale', 'supprimerEtudeSol']);

export const EtatDossierComputed = {
  ...mapState('etatdossier', {
    EtatDossier: (state) => state.EtatDossier,
   }),
  ...mapGetters('etatdossier', ['EtatDossier','selectEtatDossier']),
}


export const ClientComputed = {
  ...mapState('client', {
    ListeService: (state) => state.ListeService,
   }),
  ...mapGetters('client', ['ListeChargerAffaire','SelectUser','ListeUser','ListeClient','SelectClient','DetailsClient','totalPagination']),
}

export const DashboardComputed = {
  ...mapGetters('dashboard', ['stats', 'notifications']),
}

export const FileComputed = {
  ...mapState('file', {
    currentFile: (state) => state.currentFile,
   }),
  ...mapGetters('file', ['ListePochette','currentFile','ListeFile','ListeSearchDevis']),
}

export const FacturationComputed = {
  ...mapGetters('facturation', ['FacturationDossier', 'FacturationChargement']),
}

export const SignatureComputed = {
  ...mapState('signature', {
    currentFile: (state) => state.currentFile,
   }),
  ...mapGetters('signature', ['Signature']),
}


export const EmailComputed = {
  ...mapState('email', {
    currentFile: (state) => state.currentFile,
   }),
  ...mapGetters('email', ['ListeHistorique','HistoriqueLoading','contentEmail']),
}

// Messagerie Gmail (src/views/pages/messagerie)
export const MessagerieComputed = {
  ...mapGetters('messagerie', ['compteMessagerie', 'libellesMessagerie', 'nonLusBoite']),
}

export const authMethods = mapActions('auth',['logIn', 'logOut', 'register', 'resetPassword','askPasswordReset','confirmPasswordReset','Whoami','updateUser','updateEntreprise','updatePassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const servicesMethods = mapActions('service', ['updateCateService','createCategService','deleteCategService','getCategService','createService','getService','updateService','deleteService','SearchService'])
export const clientsMethods = mapActions('client', ['createChargeAffaire','getAllUserChargeAffaire','getClientWithPagination','updateEtatClient','createListeUser','updateListeUser','deleteListeUser','getAllUser','createClient','getClient','updateClient','deleteClient','supprimerDossiers','SearchClient','getDetailsClient'])

export const FileMethods = mapActions('file', ['deleteMultiple','uploadImageDossier','getPochete','deletePochette','UpdateCurrentDevisById','searchDevisById','resetListeSearch','searchDevis','updateEtat','convertirToFacture','createFile','generateFile','resetCurrentFile','getDocuments','getAllDocuments','getPochettesRecap','getPochetteNames','savePochetteName','downloadPochetteZip','SearchFile','deleteFile'])

export const FacturationMethods = mapActions('facturation', ['getFacturationDossier','accepterDevis','annulerAcceptationDevis','simulerFacture','creerBrouillonFacture','modifierBrouillonFacture','supprimerBrouillonFacture','emettreDocumentFacturation','getDocumentFacturation','enregistrerReglement','annulerReglement','simulerAvoir','creerAvoir','telechargerPdfFacturation','telechargerProforma','transmettreDocument','etatTransmission'])

export const EmailMethods = mapActions('email', ['getcontentemail','send_notif','send_email','getHistorique'])
export const MessagerieMethods = mapActions('messagerie', ['getCompteMessagerie','urlConnexionGmail','deconnecterGmail','getLibellesMessagerie','creerLibelleMessagerie','getConversations','getConversation','modifierConversations','corbeilleConversations','restaurerConversations','getPieceJointe','envoyerMessage','enregistrerBrouillonMessage','getBrouillonMessage','supprimerBrouillonMessage','rechercherContactsMessagerie','rechercherDossiersMessagerie'])
export const SignatureMethods = mapActions('signature', ['createSignature','getSignature'])

export const AssuranceMethods = mapActions('assurance', ['updateExpertAssuranceDossier','RESETEXPERTASSURANCE','getExpertAssuranceBySearch','add_exprtAssurre','createExpertAssurance','createExpertAssurre','deleteExpertAssurre','getExpertAssurance',"getExpertAssurre",'createAssurance','getAssurance','updateAssurance','deleteAssurance','getAssuranceBySearch','RESETASSURANCE','updateAssuranceDossier'])
export const EtatDossierMethods = mapActions('etatdossier', ['createEtatDossier','getEtatDossier','updateEtatDossier','deleteEtatDossier'])
export const GestionnaireMethods = mapActions('gestionnaire', ['createGestionnaire','getGestionnaire','updateGestionnaire','deleteGestionnaire'])
export const RemarqueMethods = mapActions('remarque', ['deleteCommentaire','getCommentaire','createCommentaire'])
export const DashboardMethods = mapActions('dashboard', ['getStats','getNotifications','globalSearch','getDossierResume'])
export const AnalyseMethods = mapActions('analyse', ['getAnalyseFinanciere','getDocumentsAnalyse','marquerAnterieuresPayees'])


